export default __webpack_public_path__ + "static/ico-mentor-b0db20dc1844010f42dad85a4aa2d10c.svg";